"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var tiny = (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 24px;\n    min-width: 24px;\n    font-size: 12px;\n    padding: 0px 8px;\n"], ["\n    height: 24px;\n    min-width: 24px;\n    font-size: 12px;\n    padding: 0px 8px;\n"])));
var small = (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 32px;\n    min-width: 32px;\n    padding: 0px 12px;\n    font-size: 12px;\n"], ["\n    height: 32px;\n    min-width: 32px;\n    padding: 0px 12px;\n    font-size: 12px;\n"])));
var normal = (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 40px;\n    min-width: 40px;\n    font-size: 14px;\n    padding: 0px 16px;\n"], ["\n    height: 40px;\n    min-width: 40px;\n    font-size: 14px;\n    padding: 0px 16px;\n"])));
var big = (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 48px;\n    min-width: 48px;\n    font-size: 16px;\n    padding: 0px 18px;\n"], ["\n    height: 48px;\n    min-width: 48px;\n    font-size: 16px;\n    padding: 0px 18px;\n"])));
var huge = (0, _styledComponents.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 50px;\n    min-width: 50px;\n    font-size: 18px;\n    padding: 0px 20px;\n"], ["\n    height: 50px;\n    min-width: 50px;\n    font-size: 18px;\n    padding: 0px 20px;\n"])));
var sizes = {
  tiny: tiny,
  small: small,
  normal: normal,
  big: big,
  huge: huge
};
var _default = sizes;
exports.default = _default;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;